import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@mui/material';
import ArrowRightIcon from '@watershed/icons/components/ArrowRight';
import { routeForClimateProgramTimeline } from '@watershed/shared-universal/dashboardRoutes';
import Button from '@watershed/ui-core/components/Button';

export default function TitleCard({ orgName }: { orgName: string }) {
  return (
    <Box
      paddingX={2}
      paddingY={1.5}
      borderBottom={(theme) => `1px solid ${theme.palette.border}`}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor={(theme) => theme.palette.white}
    >
      <Typography variant="h2">
        <Trans>{orgName}’s sustainability program</Trans>
      </Typography>
      <Button
        href={routeForClimateProgramTimeline()}
        color="primary"
        endIcon={<ArrowRightIcon />}
      >
        <Trans>Sustainability program timeline</Trans>
      </Button>
    </Box>
  );
}
